import { makePropCacheMixin } from '../utils/cache';
export var listenersMixin = makePropCacheMixin('$listeners', 'bvListeners');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/listeners.js
// module id = 48
// module chunks = 0